import { put, call, select } from 'redux-saga/effects'

import { cityIdSagaSelector } from 'reduxModules/selectors/CitySelectors'
import { bookingSagaSelector } from 'reduxModules/selectors/BookingSelectors'
import { routeIdSelector, fromUaRouteSelector, routeCompanySelector } from 'reduxModules/selectors/RouteSelectors'
import { dateSelector } from 'reduxModules/selectors/DateSelectors'
import { companySelector, isUserWithFullAccessSelector } from 'reduxModules/selectors/UserSelectors'
import { connectionPricesSagaSelector } from 'reduxModules/selectors/PriceSelectors'
import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { sortBy, createDateId } from 'services/helpers'
import { allCities } from 'constants/arrays'

import { rsf, firebase } from '../../firebase'

export function* getAllCitiesSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const res = yield call(rsf.firestore.getCollection, `cities`)

    if (!res.empty) {
      const cities = []

      yield res.forEach(city => cities.push({ id: city.id, ...city.data() }))

      const sourted = sortBy(cities, allCities, 'label')

      yield put(responseSuccess(sourted))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження міст!'
    }))
  }
}

export function* getRouteCitiesSaga(action) {
  const { responseSuccess, responseFailure, data: routeId } = action

  const splitedRouteId = routeId.split('_')

  try {
    const fromUaRoute = yield select(fromUaRouteSelector)
    const res = yield call(rsf.firestore.getCollection, `routes/${routeId}/cities`)
    const cities = []
    const returnCities = []

    res.forEach(city => cities.push({ routeId, id: city.id, ...city.data() }))

    const sourted = sortBy(cities, allCities, 'label')

    if (fromUaRoute) {
      const returnRouteId = splitedRouteId[1] + '_' + splitedRouteId[0]

      const res = yield call(rsf.firestore.getCollection, `routes/${returnRouteId}/cities`)

      res.forEach(city => returnCities.push({ returnRouteId, id: city.id, ...city.data() }))
    }

    const returnSourted = sortBy(returnCities, allCities, 'label')

    yield put(responseSuccess({ routeCities: sourted, returnRouteCities: returnSourted }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження міст!'
    }))
  }
}

export function* setSystemCitySaga(action) {
  const { responseSuccess, responseFailure, data: { id, field, value } } = action

  try {
    if (field === 'to') {
      const { from } = yield select(bookingSagaSelector, id)
      const fromId = yield select(cityIdSagaSelector, from)
      const toId = yield select(cityIdSagaSelector, value)
      const price = yield select(connectionPricesSagaSelector, { from: fromId, to: toId })

      yield call(rsf.firestore.setDocument, `bookings/${id}`, { [field]: value, price }, { merge: true })
    } else {
      yield call(rsf.firestore.setDocument, `bookings/${id}`, { [field]: value }, { merge: true })
    }

    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Місто змінено!'
    }))
    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час зміни міста!'
    }))
  }
}

export function* setCityStationSaga(action) {
  const { responseSuccess, responseFailure, data: { id, value } } = action

  try {
    yield call(rsf.firestore.setDocument, `cities/${id}`, { station: value }, { merge: true })

    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Зупинку змінено!'
    }))
    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час зміни зупинки!'
    }))
  }
}

export function* setCityTimeSaga(action) {
  const { responseSuccess, responseFailure, data: { id, name, value, routeId } } = action

  try {

    yield call(
      rsf.firestore.setDocument,
      `routes/${routeId}/cities/${id}`,
      { [name]: value },
      { merge: true }
    )

    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Чвс змінено!'
    }))
    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час зміни часу!'
    }))
  }
}

export function* disableCitySaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const date = yield select(dateSelector)
    const routeId = yield select(routeIdSelector)
    const dateId = createDateId(date)
    const routeCompany = yield select(routeCompanySelector)
    const company = yield select(companySelector)
    const isUserWithFullAccess = yield select(isUserWithFullAccessSelector)

    if (!isUserWithFullAccess && routeCompany !== company) {
      yield put(snackbarActions.showSnackbar({
        type: 'error',
        message: 'Доступ відсутній!'
      }))

      yield put(responseFailure({ id: data.id, checked: data.checked }))

      return
    }

    if (data.checked) {
      yield call(
        rsf.firestore.setDocument,
        `routes/${routeId}/info/${dateId}`,
        {
          lastModified: firebase.firestore.FieldValue.serverTimestamp(),
          disabledCities: firebase.firestore.FieldValue.arrayUnion(data.id)
        },
        { merge: true }
      )
    } else {
      yield call(
        rsf.firestore.setDocument,
        `routes/${routeId}/info/${dateId}`,
        {
          lastModified: firebase.firestore.FieldValue.serverTimestamp(),
          disabledCities: firebase.firestore.FieldValue.arrayRemove(data.id)
        },
        { merge: true }
      )
    }

    const res = data.checked ? 'заблоковане' : 'розблокаване'

    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: `Місто ${res}!`
    }))

    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure({ id: data.id, checked: data.checked }))
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час блокування міста'
    }))
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/CitySagas.js